/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

export namespace UIResourceTypes {
    const _KabResourceTypesSelectionDivId : string = "ui-workspaces-resources-selection-div";

    export enum EKabResourceType {
        Model = "model",
        Quantity = "quantity",
        Board = "board"
    }

    export function InitializeUI(): HTMLDivElement {
        let rootDiv = document.createElement("div")
        rootDiv.id = _KabResourceTypesSelectionDivId;
        rootDiv.style.display = "flex";
        rootDiv.style.flexFlow = "nowrap";
        rootDiv.style.alignItems = "center";

        // Model
        const modelResourceTypeCheckBox: HTMLInputElement = document.createElement("input");
        modelResourceTypeCheckBox.id = _KabResourceTypesSelectionDivId + "-" + EKabResourceType.Model;
        modelResourceTypeCheckBox.setAttribute("type", "radio");
        modelResourceTypeCheckBox.setAttribute("name", "kab-resource");
        const modelResourceTypeLabelElement: HTMLLabelElement = document.createElement("label");
        modelResourceTypeLabelElement.textContent = "Models";
        modelResourceTypeLabelElement.setAttribute("for", modelResourceTypeCheckBox.id);
        rootDiv.appendChild(modelResourceTypeCheckBox);
        rootDiv.appendChild(modelResourceTypeLabelElement);

        // Quantity
        const quantityResourceTypeCheckBox2: HTMLInputElement = document.createElement("input");
        quantityResourceTypeCheckBox2.id = _KabResourceTypesSelectionDivId + "-" + EKabResourceType.Quantity;
        quantityResourceTypeCheckBox2.setAttribute("type", "radio");
        quantityResourceTypeCheckBox2.setAttribute("name", "kab-resource");
        const quantiyResourceTypeLabelElement2: HTMLLabelElement = document.createElement("label");
        quantiyResourceTypeLabelElement2.textContent = "Quantities";
        quantiyResourceTypeLabelElement2.setAttribute("for", quantityResourceTypeCheckBox2.id);
        rootDiv.appendChild(quantityResourceTypeCheckBox2);
        rootDiv.appendChild(quantiyResourceTypeLabelElement2);
        rootDiv.appendChild(document.createElement("br"));

        // Board
        const boardResourceTypeCheckBox3: HTMLInputElement = document.createElement("input");
        boardResourceTypeCheckBox3.id = _KabResourceTypesSelectionDivId + "-" + EKabResourceType.Board;
        boardResourceTypeCheckBox3.setAttribute("type", "radio");
        boardResourceTypeCheckBox3.setAttribute("name", "kab-resource");
        boardResourceTypeCheckBox3.setAttribute("checked", "true");
        const boardResourceTypeElement3: HTMLLabelElement = document.createElement("label");
        boardResourceTypeElement3.textContent = "Boards";
        boardResourceTypeElement3.setAttribute("for", boardResourceTypeCheckBox3.id);
        rootDiv.appendChild(boardResourceTypeCheckBox3);
        rootDiv.appendChild(boardResourceTypeElement3);
        rootDiv.appendChild(document.createElement("br"));

        return rootDiv;
    }
    export function GetSelectedKabResourceType() : EKabResourceType {
        let oKabResourceType : EKabResourceType = EKabResourceType.Board;

        const resourceTypesDiv : HTMLElement|null = document.getElementById( _KabResourceTypesSelectionDivId );
        if( resourceTypesDiv ) {
            const modelTypeRadioButton : HTMLElement|null = resourceTypesDiv.querySelector( "#" + _KabResourceTypesSelectionDivId + "-" + EKabResourceType.Model);
            const quantityTypeRadioButton : HTMLElement|null = resourceTypesDiv.querySelector( "#" + _KabResourceTypesSelectionDivId + "-" + EKabResourceType.Quantity);
            const boardTypeRadioButton : HTMLElement|null = resourceTypesDiv.querySelector( "#" + _KabResourceTypesSelectionDivId + "-" + EKabResourceType.Board);

            if( modelTypeRadioButton && quantityTypeRadioButton && boardTypeRadioButton ) {
                const isModelTypeChecked : boolean = (<HTMLInputElement>modelTypeRadioButton).checked;
                const isQuantityTypeChecked : boolean = (<HTMLInputElement>quantityTypeRadioButton).checked;
                const isBoardTypeChecked : boolean = (<HTMLInputElement>boardTypeRadioButton).checked;
                if( isModelTypeChecked ) {
                    oKabResourceType = EKabResourceType.Model;
                } else if ( isQuantityTypeChecked ) {
                    oKabResourceType = EKabResourceType.Quantity;
                } else if ( isBoardTypeChecked ) {
                    oKabResourceType = EKabResourceType.Board;
                }
            }
        }

        return oKabResourceType;
    }
}